<script setup>
import {onBeforeMount, onMounted, reactive, ref} from 'vue'
import router from "@/router/index.js";
import {getRoute} from "@/hooks/getRoute.js";
import {addServicePhotography, editServicePhotography, listServicePhotographyDetail} from "@/api/servicePhotographer/servicePhotographer.js";

const loading = ref(false)
/*获取路由信息，带参则为修改*/
const {route} = getRoute()
// 带参则为修改
const isEdit = ref(false)
onBeforeMount(async () => {
  isEdit.value = Boolean(route.query.photographyId)
  if (isEdit.value) {
    await getDetail(route.query.photographyId)
  }
})
/*获取商店信息*/
const getDetail = async (photographyId) => {
  loading.value = true
  try {
    const res = await listServicePhotographyDetail(photographyId)
    if (!res) throw new Error("null")
    Object.assign(ruleForm, res);
    loading.value = false
  } catch (e) {
    console.log(e)
    if (e.message === "null") {
      ElMessage({
        type: "warning",
        message: "暂无此服务项目数据",
        duration: 3000,
        onClose: () => {
          router.push("/listServicePhotographer")
        }
      })
    }
  }
}
/*表单信息*/
// 表单大小
const formSize = ref('large')
// 表单锚点
const ruleFormRef = ref()
// 表单信息
const ruleForm = reactive({
  photographyName: null,
  photographyNameEn: "Coming Soon ...",
  photographyShortName: null,
  photographyShortNameEn: "Coming Soon ...",
})
// 名称校验规则
const checkName = (rule, value, callback) => {
  if (!ruleForm.photographyName) {
    return callback(new Error("名称（中文）不能为空！"))
  }
  if (!ruleForm.photographyNameEn) {
    return callback(new Error("名称（English）不能为空！"))
  }
  return callback()
}
// 短名称校验规则
const checkShortName = (rule, value, callback) => {
  if (!ruleForm.photographyShortName) {
    return callback(new Error("短名称（中文）不能为空！"))
  }
  if (!ruleForm.photographyShortNameEn) {
    return callback(new Error("短名称（English）不能为空！"))
  }
  return callback()
}
// 表单校验规则
const rules = reactive({
  photographyName: [
    {required: true, validator: checkName, trigger: 'blur'},
  ],
  photographyShortName: [
    {required: true, validator: checkShortName, trigger: 'blur'},
  ],
})
// 表单校验
const submit = async () => {
  loading.value = true
  await ruleFormRef.value.validate(async (valid, fields) => {
    if (valid) {
      await createServicePhotography()
    } else {
      ElMessage.error("请根据提示修改表单信息")
      loading.value = false
    }
  })
}
// 创建服务摄影
const createServicePhotography = async () => {
  console.log("ruleForm:", ruleForm)
  try {
    if (isEdit.value) {
      await editServicePhotography(ruleForm)
    } else {
      await addServicePhotography(ruleForm)
    }
    ElMessage({
      type: "success",
      message: isEdit.value ? "修改成功" : "创建成功",
      duration: 3000
    })
    loading.value = false
    router.push('/listServicePhotographer')
  } catch (e) {
    console.log(e)
    loading.value = false
  }
}
// 清空表单信息
const resetForm = () => {
  router.back()
}

/*中英文切换输入框相关Tab*/
// 名称tab
const nameTab = ref("zh")
// 描述tab
const introTab = ref("zh")
</script>

<template>
  <div class="container_box">
    <v-container class="flex_center">
      <el-form
          ref="ruleFormRef"
          style="max-width: 100%"
          :model="ruleForm"
          :rules="rules"
          label-width="auto"
          class="demo-ruleForm"
          :size="formSize"
          status-icon
          v-loading="loading"
      >
        <el-form-item label="名称：" prop="photographyName">
          <el-tabs
              v-model="nameTab"
              type="card"
              class="demo-tabs"
          >
            <el-tab-pane label="中文" name="zh">
              <el-input style="width: 498px;" show-word-limit v-model="ruleForm.photographyName" maxlength="40" placeholder="名称最长40个字" />
            </el-tab-pane>
            <el-tab-pane label="English" name="en">
              <el-input style="width: 498px;" show-word-limit v-model="ruleForm.photographyNameEn" maxlength="90" placeholder="The name should be up to 90 characters long" />
            </el-tab-pane>
          </el-tabs>
        </el-form-item>
        <el-form-item label="简称：" prop="photographyShortName">
          <el-tabs
              v-model="introTab"
              type="card"
              class="demo-tabs"
          >
            <el-tab-pane label="中文" name="zh">
              <el-input style="width: 498px;" show-word-limit v-model="ruleForm.photographyShortName" maxlength="10" placeholder="名称最长10个字" />
            </el-tab-pane>
            <el-tab-pane label="English" name="en">
              <el-input style="width: 498px;" show-word-limit v-model="ruleForm.photographyShortNameEn" maxlength="90" placeholder="The name should be up to 90 characters long" />
            </el-tab-pane>
          </el-tabs>
        </el-form-item>
        <el-form-item label=" ">
          <div>
            <v-row>
              <v-col>
                <v-btn @click="resetForm">取消</v-btn>
              </v-col>
              <v-col>
                <v-btn color="primary" @click="submit">保存</v-btn>
              </v-col>
            </v-row>
          </div>
        </el-form-item>
      </el-form>
    </v-container>
  </div>
</template>

<style scoped>

</style>
